

export const CodeUrl = {
    //   <--website URL details-->
    instagram:"https://www.instagram.com/",
    githubUrl:"https://github.com/SmileVP",
    linkedinUrl:"https://www.linkedin.com/",
    blank:"_blank" 
}


